module.exports = __webpack_public_path__ + "img/register-account-logo.5e6ea00e.jpg";